import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    isCartOpen: false,
    settings: [],
    apiUrl: useRuntimeConfig().public.apiUrl,
  }),

  getters: {
    cartItemCount: () => {
      const cartItems = localStorage.getItem('cart');
      if (!cartItems) return 0;
      const cart = JSON.parse(cartItems);
      return cart.reduce((total, item) => total + item.quantity, 0);
    },
    getSettings: (state) => state.settings,
  },

  actions: {
    toggleCart() {
      this.isCartOpen = !this.isCartOpen;
    },
    openCart() {
      this.isCartOpen = true;
    },
    closeCart() {
      this.isCartOpen = false;
    },
    setSettings(newSettings) {
      this.settings = newSettings;
    },
    getImageProduct(media) {
      const uploadUrl = useRuntimeConfig().public.imageUrl;
      return media
        ? `${uploadUrl}${media}`
        : 'https://api.le-perle.com.ua/assets/img/logo.svg';
    },
    async fetchSettings() {
      try {
        const data = await $fetch(`${this.apiUrl}settings`);
        this.setSettings(data);
      } catch (err) {
        console.error('Ошибка при получении настроек:', err);
      }
    }
  }
});